import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var NoteIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M19 1a3 3 0 013 3v16a3 3 0 01-3 3H6a3 3 0 01-3-3V4a3 3 0 013-3h13zM7 3H6a1 1 0 00-1 1v16a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1h-1v1a1 1 0 01-.883.993L17 5a1 1 0 01-.993-.883L16 4V3h-1v1a1 1 0 01-.883.993L14 5a1 1 0 01-.993-.883L13 4V3h-1v1a1 1 0 01-.883.993L11 5a1 1 0 01-.993-.883L10 4V3H9v1a1 1 0 01-.883.993L8 5a1 1 0 01-.993-.883L7 4V3zm5.5 13a1 1 0 010 2H9a1 1 0 010-2zM9 12h7a1 1 0 01.117 1.993L16 14H9a1 1 0 01-.117-1.993L9 12h7zm7-4a1 1 0 01.117 1.993L16 10H9a1 1 0 01-.117-1.993L9 8h7z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
NoteIcon.isCarinaIcon = true;
export default NoteIcon;
